export const odluka_prigodna_nagrada_za_godine_staza = {
    templateId: 41,
    category: 4,
    templateTitle: "Odluka - prigodna nagrada za godine staža",
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) neoporezivo isplatiti radniku prigodnu nagradu za godine radnog staža, pri čemu je navedena isplata neoporeziva do visina koje su određene Pravilnikom o porezu na dohodak.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubraja se i prigodna nagrada za godine radnog staža tzv. jubilarna nagrada.</p>
    <p>Prigodne nagrade za godine radnog staža kod poslodavca smatraju se materijalnim pravom radnika, a koje nije izravno propisano Zakonom o radu, nego se po potrebi uređuje kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Međutim, ukoliko navedeno pravo nije propisano pravilnikom o radu ili kolektivnim ugovorom odnosno ako nije određeno ugovorom o radu, onda poslodavac samostalno odlučuje hoće li to pravo omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Neoporezivi iznosi prigodne (jubilarne) nagrade radnicima propisani Pravilnikom o porezua na dohodak su sljedeći:</p>
    <p>– za 10 godina radnog staža do 1.500,00 kn,</p>
    <p>– za 15 godina radnog staža do 2.000,00 kn,</p>
    <p>– za 20 godina radnog staža do 2.500,00 kn,</p>
    <p>– za 25 godina radnog staža do 3.000,00 kn,</p>
    <p>– za 30 godina radnog staža do 3.500,00 kn,</p>
    <p>– za 35 godina radnog staža do 4.000,00 kn,</p>
    <p>– za 40 godina radnog staža do 5.000,00 kn.</p>
    <p>Prigodne nagrade za radni staž porezno su priznati trošak s aspekta utvrđivanja osnovice poreza na dobit, no samo do gore navedenih iznosa.</p>
    <p>Jubilarne nagrade su izuzete od ovrhe (do propisanih iznosa do kojih se ne smatraju oporezivim primitkom) te se u slučaju blokade računa radnika uplaćuju na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
  // <p>Gore navedene primitke do dopuštenog iznosa na koji se ne plaća porez moguće je sukladno Pravilniku o porezu na dohodak isplatiti u gotovu novcu, no ta mogućnost je ograničena obvezom provedbe ovrhe prema Ovršnom zakonu, stoga se treba pridržavati važećih uputa nadležnih tijela.</p>
  //   <p>Uputu Ministarstva financija, KLASA 400/06/16-01/330 Ur.br. 513- 05 -02- 17-8 od 4. srpnja, 2017. godine kojom je određena isplata prigodnih nagradu (božićnica, uskrsnica, regres i sl.) valja primijeniti i na gotovinske isplate prigodne nagrade za godine staža te se sukladno navedenom isplata prigodne nagrade do najvišeg dopuštenog neoporezivog iznosa može obaviti ukoliko radnik izričito zahtijeva takav način isplate, te ukoliko je ispunjen jedan ili oba dolje navedena uvjeta:</p>
  //   <li> u slučaju da je određena ovrha na tražbini po računu radnika na temelju koje poslodavac ne provodi ovrhu, niti je vezan rješenjem o ovrsi te nije dužan plijeniti ovršenikova primanja (ovrhu provodi FINA),</li>
  //   <li> u slučaju do ovrhu provodi poslodavac na temelju rješenja o ovrsi kojim je ovrha određena samo (isključivo) na plaći te se ovrha provodi samo na plaći, a ne i na drugom stalnom novčanom primanju (navedeno podatak je vidljiv u rješenju o ovrsi).</li>
  //   <br>
  //   <p>Ukoliko postoje gore navedeni uvjeti za isplatu neoporezive isplate radniku u gotovini, poslodavac može isplatiti neoporezivu isplatu u gotovini samo do najvišeg neoporezivog iznosa koji su navedeni gore u tekstu.</p>
  //   <p><strong>S druge strane, ukoliko poslodavac provodi:</strong></p>
  //   <li> ovrhu općenito na imovini radnika kao ovršenika na temelju rješenja o ovrsi donesenog od strane javnog bilježnika, ili</li>
  //   <li> ovrhu na plaći i drugim stalnim novčanim primanjima, što podrazumijeva i plaću te ostale neoprezive isplate, ili</li>
  //   <li> postupa u skladu s privatnom ispravom potvrđenom po javnom bilježniku koja ima pravni učinak pravomoćnog rješenja o ovrsi, a kojom je dužnik dao suglasnost za zapljenu plaće odnosno drugog stalnog novčanog primanja (osim u dijelu u kojem je to primanje izuzeto od ovrhe),</p>
  //   <p>dužan je prigodnu nagradu (božićnicu, uskrsnicu, regres i sl.) isplatiti na račun kojeg je ovrhovoditelj naveo u rješenju o ovrsi tj. poslodavcu je u tom slučaju zabranjeno radniku isplatiti regres za korištenje godišnjeg odmora u gotovini.</p>
  //   <p>Slično se navodi i u mišljenju Ministarstvo pravosuđa, Klasa: 740-11/16-01/359, Urbroj: 514-04-01-02-16-02 od 16. prosinca 2016. godine te Mišljenju Porezne uprave, klasa: 410-01/14-01/45, Urbroj: 513-07-21-01/14-03 od 30. siječnja 2015. godine.</p>
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: ' ODLUKU O ISPLATI PRIGODNE NAGRADE ',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom odlukom određuje se isplata prigodne nagrade radniku'
                                },
                                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'iz',},
                                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                                { type: 'text', content: ',' },
                                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'OIB:' },
                                { type: "input",  required: true,},                                {type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
                                {type: 'text', content: 'za navršenih'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godina staža, u iznosu od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.', help: 'Ovu točku trebate odabrati ukoliko odluku donosite za svakog pojedinog radnika.'}
                            ]
                        },
        {
            parts: [
              { type: "text", content: "Ovom odlukom određuje se isplata prigodne nagrade sljedećim radnicima:"},
              { type: "text", content: "\r\n"},
              {type: "textarea", value: "", required: true,  help: 'Ovu točku trebate odabrati ukoliko odluku donosite za više radnika, pri čemu trebate navesti sve podatke iz prethodne točke (ime i prezime te ostali podaci radnika, godine staža, iznos prigodne nagrade i sl.).'},
      
          ]
        }
      ],
      value: "",
    },
  ]
},
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Prigodnu nagradu iz ove Odluke Poslodavac isplaćuje zajedno s isplatom plaće za mjesec'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Prigodnu nagradu Poslodavac isplaćuje u roku od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana od dana donošenja ove Odluke.'} ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Prigodna nagrada iz ove Odluke isplaćuje se najkasnije do'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'}]
    }],
    value: '',
}
]
},
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Prigodnu nagrada iz ove Odluke Poslodavac će isplatiti redovan račun Radnika.',
                        'Prigodnu nagrada iz ove Odluke Poslodavac će isplatiti u gotovini.',
                        'Poslodavac samostalno odlučuje u svakom pojedinom slučaju na koji način će se isplatiti naknada Radniku, u gotovini ili na redovan račun Radnika.'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                    // help: 'Prije odabira načina isplate molimo pažljivo pročitajte tekst gore u kojemu se navodi kada je dopuštena isplata prigodne nagrade u gotovini.'
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ukoliko postoji zakonska mogućnost  korištenja neoporezive isplate, pri isplati prigodne nagrade za godine staža iskoristiti će se ta porezna mogućnost.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba \r\n3) Obračun plaća',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/41_odluka_prigodna_nagrada_za_godine_staza.ts